module.exports = __webpack_public_path__ + "img/img_18.48b95921.svg";